import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import {
  ErrorDetails,
  VehicleRequestDTO,
  AddVehicleResponseDTO
} from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";

export class AddVehicleCommand extends IRequestCommand<
  IAddVehicle,
  ErrorDetails,
  IAddVehicleCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'vehicles';
}

export interface IAddVehicleCommandParameters
  extends VehicleRequestDTO,
    ICommandParameters {}

export interface IAddVehicle extends AddVehicleResponseDTO, ICommandResponse {}
